/* eslint-disable max-len */
export const AsanaIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 48 48" fill="currentColor">
            <g transform="translate(2.4 2.4) scale(1.8)">
                <path fill="currentColor" d="M18.78 12.653c-2.882 0-5.22 2.336-5.22 5.22s2.338 5.22 5.22 5.22 5.22-2.34 5.22-5.22-2.336-5.22-5.22-5.22zm-13.56 0c-2.88 0-5.22 2.337-5.22 5.22s2.338 5.22 5.22 5.22 5.22-2.338 5.22-5.22-2.336-5.22-5.22-5.22zm12-6.525c0 2.883-2.337 5.22-5.22 5.22-2.882 0-5.22-2.337-5.22-5.22 0-2.88 2.338-5.22 5.22-5.22 2.883 0 5.22 2.34 5.22 5.22z" />
            </g>
        </svg>
    );
};
